/* eslint-disable */
import * as React from 'react'
import { Button, CircularProgress, FormHelperText, Grid, Typography, getNativeSelectUtilityClasses } from '@mui/material'
import Pagination from "../../../../components/TablePagination"
import { SnackbarOrigin } from '@mui/material/Snackbar'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal';
import GenericModal from '../../../../components/Modal'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import Paper from '@mui/material/Paper'
import Checkbox from '@mui/material/Checkbox'
import CloseIcon from '@mui/icons-material/Close'
import { fetchDeviceList, getAssetStateData, updateAssetStateInfo, resetUpdateStateParams } from '../../redux/actionCreators'
import { visuallyHidden } from '@mui/utils'
import { type RootState } from '../../../../store'
import { DeviceListState } from '../../redux/deviceListSlice'
import { type ConnectedProps, connect } from 'react-redux'
import LanguageStrings from '../../../../i18n/locales'
import { useNavigate } from 'react-router-dom'
import { changeAssetId } from '../../../device-details/redux/assetIdSlice'
import { useDispatch } from 'react-redux'
import { useAuth } from 'react-oidc-context'
import AuthError from '../../../../components/ErrorComponents/AuthError'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { IconButton, Menu, MenuItem } from '@mui/material'
import { GenericDropdown, type Option } from '../../../../components/GenericDropdown'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AssetStatesTypeDataState } from '../../redux/assetStatesSlice'
import { type assetStateReq } from '../../services/updateAssetstate'
import { useSelector } from 'react-redux'
import dayjs, { type Dayjs } from "dayjs";
import { type Tag } from '../../services/deviceListService'
import { useRef } from 'react'
import { Button as GenericButton } from '../../../../components/Button'
import { UpdateAssetStateInfo } from '../../redux/updateAssetStateSlice'
import { stateUpdateModel } from './StateUpdateModel'

const TableStrings = LanguageStrings().AMIDataCollectionStrings.TableComponent

export interface State extends SnackbarOrigin {
    open: boolean
}

let dateLabel = 'Installation Date'

const WhiteDatePicker = styled(DatePicker)({
    "& input": {
        color: "#b8b6b6",
        padding: '10px 14px'
    },
});

const CustomLocalizationProviderWrapper = styled("div")({
    backgroundColor: "#5c5b5bdd",
    borderRadius: "4px",
})

interface Data {
    name: string,
    serial_number: string,
    latitude: number,
    longitude: number,
    install_date: Date | null,
    removal_date: Date | null,
    tag: Tag[],
    state: string | null
}

const successModalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 399,
    bgcolor: '#272727',
    fontFamily: 'Honeywell Sans Web',
    p: 4,
    borderRadius: '5px'
}

export type Order = 'asc' | 'desc'
interface HeadCell {
    disablePadding: boolean;
    id: any;
    label: string;
    numeric: boolean;
    sortable: boolean;
}

const headCells: readonly HeadCell[] = [
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: TableStrings.Name,
        sortable: true
    },
    {
        id: 'serial_number',
        numeric: false,
        disablePadding: false,
        label: TableStrings.SerialNumber,
        sortable: true
    },
    {
        id: 'latitude',
        numeric: false,
        disablePadding: false,
        label: TableStrings.Latitude,
        sortable: true
    },
    {
        id: 'longitude',
        numeric: false,
        disablePadding: false,
        label: TableStrings.Longitude,
        sortable: true
    },
    {
        id: 'install_date',
        numeric: false,
        disablePadding: false,
        label: TableStrings.InstallDate,
        sortable: true
    }, {
        id: 'removal_date',
        numeric: false,
        disablePadding: false,
        label: TableStrings.RemovalDate,
        sortable: true
    },
    {
        id: 'tag',
        numeric: false,
        disablePadding: false,
        label: TableStrings.Tag,
        sortable: false
    },
    {
        id: 'state',
        numeric: false,
        disablePadding: false,
        label: TableStrings.State,
        sortable: false
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'ACTION',
        sortable: false
    }
]

function EnhancedTableHead(props: any): any {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, deviceList, deviceListCount } = props
    const createSortHandler =
        (newOrderBy: keyof Data) => (event: React.MouseEvent<unknown>) => {
            onRequestSort(event, newOrderBy)
        }
    // istanbul ignore else
    if (deviceList !== null && deviceList !== undefined) {
        return (
            <TableHead data-testid="table-header">
                <TableRow>
                    <StyledTableCell padding="checkbox">
                        <Checkbox
                            sx={{ color: "#909090" }}
                            data-testid="device-table-header-checkbox"
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={rowCount > 0 && numSelected === rowCount}
                            onChange={onSelectAllClick}
                            inputProps={{
                                'aria-label': 'select all devices',
                            }}
                        />
                    </StyledTableCell>
                    {headCells.map((headCell: any) => (
                        <StyledTableCell
                            key={headCell.id}
                            align={headCell.numeric ? 'right' : 'left'}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                hideSortIcon={!headCell.sortable}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={headCell.sortable ? createSortHandler(headCell.id) : undefined}
                                aria-label={headCell.label}
                                data-testid="test-sort"

                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </StyledTableCell>
                    ))}
                </TableRow>
            </TableHead>
        )
    }
}


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: "#F0F0F0",
        fontWeight: "700",
        fontSize: 12,
        border: "2px solid #202020",
        padding: "5px 16px",
        fontFamily: "Honeywell Sans Web"
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        color: "#d0d0d0",
        paddingLeft: "17px",
        borderBottom: "1px solid #202020",
        borderRight: 0,
        fontFamily: "Honeywell Sans Web"
    },
}))

export interface Sort {
    order: Order
    orderBy: string
}

function DeviceList(props: AllProps) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [selectedRow, setSelectedRow] = React.useState<any>(null)
    const [showStateChangeModal, setStateChangeModal] = React.useState<boolean>(false)
    const assetStateTypeData = useSelector((state: RootState) => state.AssetStatesTypeData?.AssetStatesTypeData)
    const [reqError, setReqError] = React.useState<boolean>(false)
    const [reqDateError, setReqDateError] = React.useState<boolean>(false)
    const [AssetStateTypeOptions, setAssetStateTypeOptions] = React.useState<Option[]>([])
    const auth = useAuth()
    const [selected, setSelectedAsset] = React.useState<readonly string[]>([])
    const [selectall, setSelectedAll] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const [showMenu, setShowMenu] = React.useState(false)
    const [showStateUpdatePopup, setShowStateUpdatePopup] = React.useState<boolean>(false)
    const [previousState, SetPreviousState]  = React.useState('')
    const defaultDateAsset = dayjs(new Date())
    const [installationStateDate, setInstallationStateDate] = React.useState<Dayjs | null | undefined>(defaultDateAsset)
    const [showAlertPopup, setShowAlertPopup] = React.useState<boolean>(false)
    const wrapperRef = useRef(null)
    useOutsideAlerter(wrapperRef)

    // istanbul ignore next
    function useOutsideAlerter (ref: any) {
        React.useEffect(() => {
          function handleClickOutside (event: any) {
            if (ref.current && !ref.current.contains(event.target)) {
                setAnchorEl(null)
                setSelectedRow(null)
            }
          }
          document.addEventListener('mousedown', handleClickOutside)
          return () => {
            document.removeEventListener('mousedown', handleClickOutside)
          }
        }, [ref])
      }

    let active_id: string;

    const initialState = {
        assetStateType: '',
        assetIds: [],
        transitionDate: installationStateDate,
        confirmedUpdate: false
    }

    const [addState, dispatchState] = React.useReducer((curVal: any, newVal: any) => ({ ...curVal, ...newVal }), initialState)

    React.useEffect(() => {
        if (props.searchVal === '') {
            fetchAllAssetList()
        } else if (props.searchVal !== '') {
            props.performAction()
        }
    }, [props.page, props.sort])

    React.useEffect(() => {
        props.getAssetStateData(auth.user?.profile.customer as string)
        props.resetUpdateStateParams()
    }, [])

    const fetchAllAssetList = () => {
        // istanbul ignore else
        if (props.page >= 1) {
            props.fetchDeviceList(props.page - 1, props.rowsPerPage, props.sort.order, props.sort.orderBy, auth.user?.profile.customer as string)
        }
    }

    const closeStateChangeModal = () => {
        setStateChangeModal(false)
        setReqError(false)
        setReqDateError(false)
        setInstallationStateDate(defaultDateAsset)
        dispatchState(initialState)
        props.fetchDeviceList(props.page - 1, props.rowsPerPage, props.sort.order, props.sort.orderBy, auth.user?.profile.customer as string)
        setSelectedAsset([])
        dateLabel = 'Installation Date'
    }

    const handleRequestSort =
        (event: React.MouseEvent<unknown>, newOrderBy: keyof Data) => {
            const isAsc = props.sort.orderBy === newOrderBy && props.sort.order === 'asc'
            const toggledOrder = isAsc ? 'desc' : 'asc'
            props.setSort({ order: toggledOrder, orderBy: newOrderBy })
        }

    const handleEllipsisClick = (event: any, row: string): void => {
        setAnchorEl(event.currentTarget)
        setSelectedRow(row)
        dispatchState({ ...addState, 'assetIds': [row] })
    }

    React.useEffect(() => {
        if (assetStateTypeData !== null && assetStateTypeData?.length > 0) {
            const assetStateTypes: Option[] = []
            assetStateTypeData?.forEach((assetState: any) => {
                assetStateTypes.push({
                    value: assetState.asset_state_type_id,
                    label: assetState.asset_state_type_name
                })
                if(assetState.asset_state_type_name === 'Active'){
                    active_id = assetState.asset_state_type_id
                }
            })
            setAssetStateTypeOptions(assetStateTypes)
        }
    }, [assetStateTypeData])

    const handleChooseState = (name: string, value: string) => {
        let label = name + 'Options';
        let AssetStateTypeIdName = assetStateTypeData.find((a: { asset_state_type_id: string }) => a.asset_state_type_id == value).asset_state_type_name
        if (AssetStateTypeIdName == 'Active') {
            dateLabel = 'Activation Date'
        } else if (AssetStateTypeIdName == 'Inactive') {
            dateLabel = 'Inactivation Date'
        } else if (AssetStateTypeIdName == 'Shipped') {
            dateLabel = 'Shipping Date'
        } else if (AssetStateTypeIdName == 'Removed') {
            dateLabel = 'Removal Date'
        }
        dispatchState({ ...addState, [name]: AssetStateTypeIdName, 'assetStateType': AssetStateTypeIdName })
    }

    const handleInstallationDate = (val: any) => {
        setInstallationStateDate(val);
        dispatchState({ ...addState, 'transitionDate': val })
    }

    const handleSubmit = (newState?: assetStateReq) => {
        if (newState !== undefined) {
            props.updateAssetStateInfo(newState, auth.user?.profile.customer as string)
            setStateChangeModal(false)
            setShowStateUpdatePopup(true)
            dispatchState({ ...addState, 'assetStateType': '' })
        }
        else if (addState.assetStateType && addState.transitionDate && addState) {
            props.updateAssetStateInfo(addState, auth.user?.profile.customer as string)
            setStateChangeModal(false)
            setShowStateUpdatePopup(true)
            // props.resetUpdateStateParams()
        } else {
            setReqError(true)
            // props.resetUpdateStateParams()
        }
    }

    const handleStateChangeClick = (rowId: string, modifyOption: string): void => {
        setStateChangeModal(true)
        setSelectedRow(null)
    }

    // istanbul ignore next
    const handleSingleStateChangeClick = (rowId: string, rowState:string, modifyOption: string): void => {
        SetPreviousState(rowState)
        if(rowState === 'Removed'){
            setAssetStateTypeOptions([{value: active_id, label: 'Active'}])
        }
        setStateChangeModal(true)
        setSelectedRow(null)
    }

    const handleMenuClose = (): void => {
        setAnchorEl(null)
        setSelectedRow(null)
    }

    const handleSelectAllClickAsset = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const currentPageAssets = props.deviceList?.deviceList?.map((n: { id: any }) => n.id)
        // istanbul ignore else
        if (event.target.checked) {
            const newSelected: string[] = []
            currentPageAssets?.forEach((id) => {
                // istanbul ignore else
                if (!selected.includes(id)) {
                    newSelected.push(id)
                }
            })
            const newSelectedlist = [...selected, ...newSelected]
            setSelectedAsset(newSelectedlist)
            dispatchState({ ...addState, 'assetIds': newSelectedlist })
        } else {
            const newSelected: string[] = []
            selected.forEach((id) => {
                if (!currentPageAssets?.includes(id)) {
                    newSelected.push(id)
                }
            })
            setSelectedAsset(newSelected)
        }
    }

    const handleRowClickAsset = (id: string): void => {
        const isIdSelected = selected.includes(id)
        // istanbul ignore next
        if (!isIdSelected) {
            const arrData = [...selected, id];
            setSelectedAsset(arrData)
            dispatchState({ ...addState, 'assetIds': arrData })
            arrData.length == props.deviceList.deviceCount ? setSelectedAll(true) : setSelectedAll(false);
        } else {
            const arrData = selected.filter((selectedId) => selectedId !== id)
            setSelectedAsset(arrData);
            dispatchState({ ...addState, 'assetIds': arrData })
            arrData.length == props.deviceList.deviceCount ? setSelectedAll(true) : setSelectedAll(false);
        }

    }

    const handleDeviceDetailClick = (assetId: string, assetName: string) => {
        dispatch(changeAssetId(assetId))
        sessionStorage.setItem('paramAssetId', assetId != null ? assetId.toString() : '')
        sessionStorage.setItem('paramAssetName', assetName != null ? assetName.toString() : '')
        navigate(`/devicedetails`)
    }

    // const handleAlert = (): boolean => {
    //     showAlertSuccess ? setShowAlertSuccess(false) : setShowAlertSuccess(true)
    //     return showAlertSuccess
    // }
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        "& th": {
            border: "1px solid #202020",
        }
    }))

    const checkIfEditInfoValid = (): boolean => {
        if(reqDateError){
            return true
        }
        return (previousState === addState.assetStateType)
      }

    const isSelected = (id: string): boolean => selected.includes(id)

    // istanbul ignore else
    if (props.deviceList.deviceList !== null && props.deviceList.deviceList !== undefined && props.deviceList.httpStatus === 200 && props.deviceList.deviceCount > 0) {
        return (
            <>
                <Box className="devices">
                    <Paper sx={{ width: '100%', mb: 2, backgroundColor: "#272727", boxShadow: "unset", color: "#F0F0F0", marginBottom: "0" }}>
                        <TableContainer className='device-table'>
                            <Table
                                sx={{ minWidth: 750, color: "#f0f0f0" }}
                                aria-labelledby="tableTitle"
                                size={'small'}
                            >
                                <EnhancedTableHead
                                    numSelected={selected.filter((id) => props.deviceList.deviceList && props.deviceList.deviceList.map((asset: any) => asset.id).includes(id)).length}
                                    order={props.sort.order}
                                    orderBy={props.sort.orderBy}
                                    onSelectAllClick={handleSelectAllClickAsset}
                                    onRequestSort={handleRequestSort}
                                    rowCount={(props.deviceList.deviceList).length}
                                    deviceList={props.deviceList.deviceList}
                                    deviceListCount={(props.deviceList.deviceList).length}
                                />
                                <TableBody>
                                    {props.deviceList.deviceList && props.deviceList.deviceList.map((row: any, index: any) => {
                                        const isItemSelected = isSelected(row.id)
                                        const labelId = `enhanced-table-checkbox-${index}`
                                        var installDate = row.install_date ? new Date(row.install_date) : null
                                        var formattedInstallDate = installDate ? installDate.toLocaleDateString('en-US') : ''
                                        var removalDate = row.removal_date ? new Date(row.removal_date) : null
                                        var formattedRemovalDate = removalDate ? removalDate.toLocaleDateString('en-US') : ''

                                        return (
                                            <StyledTableRow
                                                hover
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={row.deviceId}
                                                aria-label="devices-list-row"
                                                selected={isItemSelected}
                                                sx={{ cursor: 'pointer' }}
                                            >
                                                <StyledTableCell padding="checkbox">
                                                    <Checkbox
                                                        sx={{ color: '#909090' }}
                                                        checked={isItemSelected}
                                                        onChange={() => { handleRowClickAsset(row.id) }}
                                                        inputProps={{
                                                            'aria-labelledby': labelId,
                                                            'aria-label': 'test-checkbox'
                                                        }}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell
                                                    component="th"
                                                    id={labelId}
                                                    scope="row"
                                                    padding="none"
                                                    onClick={() => handleDeviceDetailClick(row.id, row.name)}
                                                    aria-label='device-name'
                                                    data-testid='device-name'
                                                    sx={{ color: "#64C3FF !important" }} >{row.name}</StyledTableCell>
                                                <StyledTableCell
                                                >{row.serial_number}</StyledTableCell>
                                                <StyledTableCell
                                                >{row.latitude}</StyledTableCell>
                                                <StyledTableCell >{row.longitude}</StyledTableCell>
                                                <StyledTableCell >{formattedInstallDate}</StyledTableCell>
                                                <StyledTableCell >{formattedRemovalDate}</StyledTableCell>
                                                <StyledTableCell >{row?.tag?.length > 0 ? row.tag[0].name : ''}</StyledTableCell>
                                                <StyledTableCell >{row.state}</StyledTableCell>
                                                <StyledTableCell>
                                                    <span style={{
                                                        color: '#64c3ff',
                                                        textDecoration: 'none',
                                                        paddingLeft: '2px'
                                                    }}
                                                    onClick={() => {
                                                        setSelectedRow(row)
                                                        dispatchState({ ...addState, 'assetIds': [row.id] })
                                                        handleSingleStateChangeClick(row.id, row.state, 'ChangeState')
                                                    }}data-testid="change-state-button">
                                                    {TableStrings.ChangeStateTitle}
                                                    </span>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        )
                                    })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Pagination count={props.deviceList.deviceCount} page={props.page} setPage={props.setPage} rowsPerPage={props.rowsPerPage} siblingCount={1}
                            boundaryCount={1} />
                    </Paper>
                </Box >
                {/* <StateChangeModal
                    open={showStateChangeModal}
                    closeStateChangeModal={closeStateChangeModal}
                    checkIfEditInfoValid={checkIfEditInfoValid}
                    handleInstallationDate={handleInstallationDate}
                    handleSubmit={handleSubmit}
                    addState={addState}
                    defaultDateAsset={defaultDateAsset}
                    reqError={reqError}
                /> */}
                <Modal className='state-update-modal' open={showStateChangeModal} onClose={() => { closeStateChangeModal() }}>
                    <Box sx={successModalStyle}>
                        <div className='title'>
                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <Grid item xs={10}>
                                    <Typography id='modal-modal-title' variant='h6' component='h2'>
                                        {TableStrings.ChangeStateTitle}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <CloseIcon style={{ cursor: 'pointer' }} data-testid='close-button' onClick={() => { closeStateChangeModal() }} />
                                </Grid>
                            </Grid>
                        </div>
                        <div className='state-div'>
                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <Grid item xs={12}>
                                    <GenericDropdown dataTestId='category' allowInput={true} width={336} options={AssetStateTypeOptions} value={addState.asset_state_type_name} onChange={(e) => handleChooseState('assetStateType', e.target.value)} label={'State'} />
                                    {reqError && !addState.assetStateType && <FormHelperText className='errorColor'>{'Required'}</FormHelperText>}
                                </Grid>
                                <Grid item xs={12}>
                                    <label style={{ marginBottom: '10px', display: 'block' }}>{dateLabel}*</label>
                                    <CustomLocalizationProviderWrapper>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <WhiteDatePicker
                                                disableFuture
                                                defaultValue={defaultDateAsset}
                                                slotProps={{ textField: { fullWidth: true } }}
                                                value={addState.transitionDate}
                                                onAccept={(val: any) => {
                                                    handleInstallationDate(dayjs(val)) }}
                                                onError={(error) => {setReqDateError(true)}}
                                            />
                                        </LocalizationProvider>
                                    </CustomLocalizationProviderWrapper>
                                    {reqDateError && <FormHelperText className='errorColor'>{'Future date not allowed'}</FormHelperText>}
                                </Grid>
                            </Grid>
                        </div>
                        <div className='add-modal-button-container' style={{ float: 'right' }}>
                            <Button data-testid='' className='can-btn-asset'
                                onClick={() => { closeStateChangeModal() }}
                                style={{
                                    border: '1px solid #32617f',
                                    textTransform: 'capitalize',
                                    padding: '5px 27px',
                                    marginRight: '10px'
                                }}>
                                {TableStrings.Cancel}
                            </Button>
                            <GenericButton data-testid='' className='btn-asset'
                                onClick={() => { handleSubmit() }}
                                primaryColor={checkIfEditInfoValid() ? '#B0B0B0' : undefined}
                                disabled={checkIfEditInfoValid()}
                            >
                                {TableStrings.Update}
                            </GenericButton>
                        </div>
                    </Box>
                </Modal >
                {showStateUpdatePopup
                    ? stateUpdateModel(props, setShowStateUpdatePopup, addState, dispatchState, handleSubmit, initialState, fetchAllAssetList, setSelectedAsset)
                    : <></>
                }
                {
                    (selected?.length > 1) ?
                        <>
                            <div style={{ marginTop: '40px', padding: '20px' }} className="state-button-container state-update">
                                <Button data-testid='' className='can-btn-asset'
                                    onClick={() => {
                                        setSelectedAsset([])
                                    }}
                                    style={{
                                        border: '1px solid #32617f',
                                        textTransform: 'capitalize',
                                        padding: '5px 27px',
                                        marginRight: '10px',
                                        float: 'left'
                                    }}>
                                    {TableStrings.Cancel}
                                </Button>
                                <Button data-testid='' className='btn-asset'
                                    onClick={() => {
                                        handleStateChangeClick('selected', 'ChangeState')
                                    }}
                                    style={{
                                        border: '1px solid #32617f',
                                        textTransform: 'capitalize',
                                        padding: '5px 27px',
                                        color: '#000000',
                                        backgroundColor: '#64c3ff',
                                        fontWeight: '700',
                                        float: 'right'
                                    }}>
                                    {TableStrings.ChangeStateTitle}
                                </Button>
                            </div>
                        </> : ''
                }
            </>

        )
    }
    else if (props.deviceList.isLoading) {
        return (
            <div className='CircularprogressAmi' data-testid = 'loading-spinner'>
                <CircularProgress />
            </div>
        )
    }
    else if (props.deviceList.httpStatus === 401) {
        return (
            <div className='authError'><AuthError errorMessage="Unauthorized" /></div>
        )
    }
    else if (props.deviceList.httpStatus === 403) {
        return (
            <div className='authError'><AuthError errorMessage="accessForbidden" /></div>
        )
    }
    else if ((props.deviceList.deviceList !== null && props.deviceList.deviceList !== undefined && props.deviceList.deviceList.length === 0)) {
        return (
            <div className='authError'><AuthError errorMessage="NoDataPresent" /></div>
        )
    }
    else if ((props.deviceList.loadingError?.includes('No assets found') || props.deviceList.loadingError?.includes("Asset not found"))) {
        return (
            <div className='authError'><AuthError errorMessage="NoDataPresent" /></div>
        )
    }
    else {
        return (
            <div className='authError'><AuthError errorMessage="cannotFetch" retry={fetchAllAssetList} /></div>
        )
    }

}
interface DispatchToProps {
    fetchDeviceList: (page: number, size: number, sortdir: string, sortfield: string, tenantId: string) => void,
    getAssetStateData: (tenantId: string) => void,
    updateAssetStateInfo: (assetStateParamter: assetStateReq, tenantId: string) => void,
    resetUpdateStateParams: () => (tenantId: string) => void,
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
    fetchDeviceList: (page: number, size: number, sortdir: string, sortfield: string, tenantId: string) => dispatch(fetchDeviceList(page, size, sortdir, sortfield, tenantId)),
    getAssetStateData: (tenantId: string) => dispatch(getAssetStateData(tenantId)),
    updateAssetStateInfo: (assetStateParamter: assetStateReq, tenantId: string) => dispatch(updateAssetStateInfo(assetStateParamter, tenantId)),
    resetUpdateStateParams: () => dispatch(resetUpdateStateParams())
})

interface StateToProps {
    deviceList: DeviceListState,
    assetState: AssetStatesTypeDataState
    updateAssetStateData: UpdateAssetStateInfo
}

const mapStateToProps = (state: RootState): StateToProps => ({
    deviceList: state.deviceList,
    assetState: state.AssetStatesTypeData,
    updateAssetStateData: state.updateAssetStateData
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>
interface ParentProps {
    searchVal: string
    performAction: () => void
    rowsPerPage: number
    page: number
    sort: Sort
    setPage: React.Dispatch<React.SetStateAction<number>>
    setSort: React.Dispatch<React.SetStateAction<Sort>>
}
type AllProps = PropsFromRedux & ParentProps

export default connector(DeviceList)